import { inputClass } from '../AuthCard.tsx';
import type { EditProps, ViewProps } from './types.ts';

export function KvListView({ content }: ViewProps<'kv_list'>) {
  if (content.items.length === 0) return null;
  return (
    <dl className="grid grid-cols-[max-content_1fr] gap-x-6 gap-y-1.5 text-sm">
      {content.items.map((item, i) => (
        <div key={i} className="contents">
          <dt className="font-medium text-gray-500">{item.label}</dt>
          <dd className="text-gray-800">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}

export function KvListEdit({ content, onChange }: EditProps<'kv_list'>) {
  const setItem = (i: number, patch: Partial<(typeof content.items)[number]>) =>
    onChange({
      ...content,
      items: content.items.map((item, j) => (j === i ? { ...item, ...patch } : item)),
    });
  return (
    <div className="space-y-2">
      {content.items.map((item, i) => (
        <div key={i} className="flex gap-2">
          <input className={inputClass} placeholder="Label" value={item.label}
            onChange={(e) => setItem(i, { label: e.target.value })} />
          <input className={inputClass} placeholder="Value" value={item.value}
            onChange={(e) => setItem(i, { value: e.target.value })} />
          <button type="button" className="text-sm whitespace-nowrap text-red-500 hover:underline"
            onClick={() => onChange({ ...content, items: content.items.filter((_, j) => j !== i) })}>
            Remove
          </button>
        </div>
      ))}
      <button type="button" className="text-sm text-blue-600 hover:underline"
        onClick={() => onChange({ ...content, items: [...content.items, { label: '', value: '' }] })}>
        Add row
      </button>
    </div>
  );
}
